import {INotificationMenuItem} from '@ngx-ivengi/cleanzone/notification-menu/notification-menu-item.interface';
import {CrudModel} from '@ngx-ivengi/crud';
import {Building} from '../building/building.model';
import {Owner} from '../owner/owner.model';
import {Note} from './note/note.model';

export class Maintenance extends CrudModel implements INotificationMenuItem {

  public status: string;
  // public stateDraft: string;
  public building: Building;
  public collapse: boolean = true;
  public visible: boolean = true;
  public owner: Owner;
  public channelCount: number;
  public notes: Note[];
  public noteDraft = new Note();

  public setStatus(status: string): Maintenance {
    if(typeof status === 'string') {
      this.status = status;
    }
    return this;
  }

  public setBuilding(building: Building): Maintenance {
    if(building instanceof Building) {
      this.building = building;
    }
    return this;
  }

  public setOwner(owner: Owner): Maintenance {
    if(owner instanceof Owner) {
      this.owner = owner;
    }
    return this;
  }

  public setChannelCount(channelCount: number): Maintenance {
    if(typeof channelCount === 'number') {
      this.channelCount = channelCount;
    }
    return this;
  }

  public setNotes(notes: Note[]): Maintenance {
    if(notes instanceof Array) {
      this.notes = notes.filter((note: Note) => {
        return (note instanceof Note);
      });
    }
    return this;
  }

  public addNote(note: Note): Maintenance {
    if(note instanceof Note) {
      this.notes.push(note);
      this.notes.sort((a: Note, b: Note) => {
        return (b.createdDate.getTime() - a.createdDate.getTime());
      });
    }
    return this;
  }

  // public isValid(): boolean {
  //   return (typeof this.stateDraft === 'string' && this.stateDraft !== this.status);
  // }

  public fromResponse(response: any): void {

    if(response.building) {
      const building = new Building();
      building.fromResponse(response.building);
      this.setBuilding(building);
    }

    if(response.owner) {
      const owner = new Owner();
      owner.fromResponse(response.owner);
      this.setOwner(owner);
    }

    this
      .setId(response.id)
      .setStatus(response.status)
      .setChannelCount(response.channelCount);

  }

  getNotificationIcon(): string {
    if(this.status === 'NEW') {
      return 'fa-exclamation-triangle';
    } else {
      return 'fa-bell';
    }
  }

  getNotificationLevel(): string {
    if(this.status === 'NEW') {
      return 'danger';
    } else {
      return 'warning';
    }
  }

  getNotificationMainText(): string {
    return `${this.building.name} - ${this.building.address.address}, ${this.building.address.city}`;
  }

  getNotificationSubText(): string {
    return `${this.channelCount} ${(this.channelCount === 1) ? 'sparing' : 'sparingen'}`;
  }

  getNotificationState(): string {
    return null;
  }

  getNotificationParams(): {[p: string]: string} {
    return undefined;
  }

}



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/brands-compart-portal-frontend/checkout/src/app/components/maintenance/maintenance.model.ts